







import {
  Component, Prop, Vue,
} from 'vue-property-decorator';

@Component({
  name: 'ABTestWrapper',
})
export default class ABTestWrapper extends Vue {
  // Props
  @Prop({ required: true, type: String })
  featureName!: string;

  @Prop({ default: false, type: Boolean })
  autoTrack!: boolean;

  @Prop({ default: '', type: String })
  trackingEvent!: string;

  // 数据属性
  private isEnabled = false;

  // 生命周期钩子
  mounted() {
    this.initializeABTest();
  }

  // 方法
  private async initializeABTest() {
    try {
      const result = await this.$service.bk.abTest({ abTestKey: this.featureName });
      this.isEnabled = result;
    } catch (error) {
      // 设置默认状态
      this.isEnabled = false;
    }
  }
}
